export enum RiskProfileStatus {
  INSUFFICIENT_ACCURACY = 'INSUFFICIENT_ACCURACY',
  REFERRAL = 'REFERRAL',
  QUOTE = 'QUOTE',
}
